import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '@/config';

const url = SUPABASE_URL || 'http://localhost:54321';
const key = SUPABASE_ANON_KEY || 'placeholder';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.warn('Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY — using placeholders');
}

export const supabase = createClient(url, key);
